import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "v-form-control-label",
    class: _vm.classes
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "v-form-control-label__text"
  }, [_c('VText', {
    attrs: {
      "component": "span"
    }
  }, [_vm._t("label"), _vm._v(_vm._s(_vm.label))], 2)], 1)], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-63901db0_0", {
    source: ".v-form-control-label[data-v-63901db0]{display:inline-flex;align-items:center;border:1px solid transparent;color:var(--g-color-on-bg);line-height:1;cursor:pointer;text-align:left}.v-form-control-label--block[data-v-63901db0]{display:flex}.v-form-control-label__text[data-v-63901db0]{font-size:1rem;height:100%;margin-left:.75em}.v-form-control-label__text>span[data-v-63901db0]{color:inherit;font-size:inherit;display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-63901db0";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var FormControlLabel = __vue_component__;
export { FormControlLabel as default };